import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';

class EipCalculatorService {
    constructor() { }
}
EipCalculatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EipCalculatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class EipCalculatorComponent {
    constructor() {
        this.currentNumber = '0';
        this.firstOperand = null;
        this.operator = null;
        this.waitForSecondNumber = false;
        this.calculatedResult = new EventEmitter();
    }
    ngOnInit() {
    }
    getNumber(v) {
        if (this.waitForSecondNumber) {
            this.currentNumber = v;
            this.waitForSecondNumber = false;
        }
        else {
            this.currentNumber === '0' ? this.currentNumber = v : this.currentNumber += v;
        }
    }
    getDecimal() {
        if (!this.currentNumber.includes('.')) {
            this.currentNumber += '.';
        }
    }
    doCalculation(op, secondOp) {
        switch (op) {
            case '+':
                return this.firstOperand += secondOp;
            case '-':
                return this.firstOperand -= secondOp;
            case '*':
                return this.firstOperand *= secondOp;
            case '/':
                return this.firstOperand /= secondOp;
            case '=':
                return secondOp;
        }
    }
    getOperation(op) {
        if (this.firstOperand === null) {
            this.firstOperand = Number(this.currentNumber);
        }
        else if (this.operator) {
            const result = this.doCalculation(this.operator, Number(this.currentNumber));
            this.currentNumber = String(result);
            this.firstOperand = result;
        }
        this.operator = op;
        this.waitForSecondNumber = true;
        if (this.operator === '=') {
            this.calculatedResult.emit(this.firstOperand);
        }
    }
    clear() {
        this.currentNumber = '0';
        this.firstOperand = null;
        this.operator = null;
        this.waitForSecondNumber = false;
    }
    handleKeyboardEvent(event) {
        this.keypressed = event.keyCode;
        switch (this.keypressed) {
            case 97: {
                this.getNumber('1');
                break;
            }
            case 98: {
                this.getNumber('2');
                break;
            }
            case 99: {
                this.getNumber('3');
                break;
            }
            case 100: {
                this.getNumber('4');
                break;
            }
            case 101: {
                this.getNumber('5');
                break;
            }
            case 102: {
                this.getNumber('6');
                break;
            }
            case 103: {
                this.getNumber('7');
                break;
            }
            case 104: {
                this.getNumber('8');
                break;
            }
            case 105: {
                this.getNumber('9');
                break;
            }
            case 96: {
                this.getNumber('0');
                break;
            }
            case 107: {
                this.getOperation('+');
                break;
            }
            case 109: {
                this.getOperation('-');
                break;
            }
            case 106: {
                this.getOperation('*');
                break;
            }
            case 111: {
                this.getOperation('/');
                break;
            }
            case 110: {
                this.getDecimal();
                break;
            }
            case 13: {
                this.getOperation('=');
                break;
            }
            case 187: {
                this.getOperation('=');
                break;
            }
            case 67: {
                this.clear();
                break;
            }
            case 49: {
                this.getNumber('1');
                break;
            }
            case 50: {
                this.getNumber('2');
                break;
            }
            case 51: {
                this.getNumber('3');
                break;
            }
            case 52: {
                this.getNumber('4');
                break;
            }
            case 53: {
                this.getNumber('5');
                break;
            }
            case 54: {
                this.getNumber('6');
                break;
            }
            case 55: {
                this.getNumber('7');
                break;
            }
            case 56: {
                this.getNumber('8');
                break;
            }
            case 57: {
                this.getNumber('9');
                break;
            }
            case 48: {
                this.getNumber('0');
                break;
            }
        }
    }
}
EipCalculatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EipCalculatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: EipCalculatorComponent, selector: "eip-calculator", outputs: { calculatedResult: "calculatedResult" }, host: { listeners: { "window:keydown": "handleKeyboardEvent($event)" } }, ngImport: i0, template: "<div class=\"calculator\" cdkDrag cdkDragRootElement=\".cdk-overlay-pane\">\r\n\r\n  <div cdkDragHandle style=\"float: left; height: 75px;width: 410px; position: absolute;\"></div>\r\n  <input  type=\"text\" class=\"calculator-screen\" [value]=\"currentNumber\" disabled />\r\n\r\n  <div class=\"calculator-keys\">\r\n\r\n    <button type=\"button\" (click) = \"getOperation('+')\" class=\"operator\" value=\"+\">+</button>\r\n    <button type=\"button\" (click) = \"getOperation('-')\" class=\"operator\" value=\"-\">-</button>\r\n    <button type=\"button\" (click) = \"getOperation('*')\" class=\"operator\" value=\"*\">&times;</button>\r\n    <button type=\"button\" (click) = \"getOperation('/')\" class=\"operator\" value=\"/\">&divide;</button>\r\n\r\n    <button type=\"button\" (click) = \"getNumber('7')\" value=\"7\">7</button>\r\n    <button type=\"button\" (click) = \"getNumber('8')\" value=\"8\">8</button>\r\n    <button type=\"button\" (click) = \"getNumber('9')\" value=\"9\">9</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('4')\" value=\"4\">4</button>\r\n    <button type=\"button\" (click) = \"getNumber('5')\" value=\"5\">5</button>\r\n    <button type=\"button\" (click) = \"getNumber('6')\" value=\"6\">6</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('1')\" value=\"1\">1</button>\r\n    <button type=\"button\" (click) = \"getNumber('2')\" value=\"2\">2</button>\r\n    <button type=\"button\" (click) = \"getNumber('3')\" value=\"3\">3</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('0')\" value=\"0\">0</button>\r\n    <button type=\"button\" (click) = \"getDecimal()\" class=\"decimal\" value=\".\">.</button>\r\n    <button type=\"button\" (click) = \"clear()\"  class=\"all-clear\" value=\"all-clear\">C</button>\r\n\r\n    <button type=\"button\" (click) = \"getOperation('=')\" class=\"equal-sign\" value=\"=\">=</button>\r\n  </div>\r\n</div>\r\n", styles: [".calculator{border:1px solid #ccc;border-radius:5px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:400px;background-color:#fff}.calculator-screen{width:100%;font-size:36px;height:80px;border:none;background-color:#1579ab;color:#fff;text-align:right;padding-right:20px;padding-left:10px}button{height:60px;background-color:#fff;border-radius:3px;border:1px solid #c4c4c4;background-color:transparent;font-size:22px;color:#1579ab;background-image:linear-gradient(to bottom,transparent,transparent 50%,rgba(0,0,0,.04));box-shadow:inset 0 0 0 1px #ffffff0d,inset 0 1px #ffffff73,inset 0 -1px #ffffff26,0 1px #ffffff26;text-shadow:0 1px rgba(255,255,255,.4)}button:hover{background-color:#eaeaea}.operator{color:#337cac}.all-clear{background-color:#1579ab;border-color:#1579ab;color:#fff}.all-clear:hover{background-color:#1579ab}.equal-sign{background-color:#1579ab;border-color:#1579ab;color:#fff;height:100%;grid-area:2 / 4 / 6 / 5}.equal-sign:hover{background-color:#1579ab}.calculator-keys{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:10px;padding:10px}\n"], directives: [{ type: i1.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { type: i1.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eip-calculator', template: "<div class=\"calculator\" cdkDrag cdkDragRootElement=\".cdk-overlay-pane\">\r\n\r\n  <div cdkDragHandle style=\"float: left; height: 75px;width: 410px; position: absolute;\"></div>\r\n  <input  type=\"text\" class=\"calculator-screen\" [value]=\"currentNumber\" disabled />\r\n\r\n  <div class=\"calculator-keys\">\r\n\r\n    <button type=\"button\" (click) = \"getOperation('+')\" class=\"operator\" value=\"+\">+</button>\r\n    <button type=\"button\" (click) = \"getOperation('-')\" class=\"operator\" value=\"-\">-</button>\r\n    <button type=\"button\" (click) = \"getOperation('*')\" class=\"operator\" value=\"*\">&times;</button>\r\n    <button type=\"button\" (click) = \"getOperation('/')\" class=\"operator\" value=\"/\">&divide;</button>\r\n\r\n    <button type=\"button\" (click) = \"getNumber('7')\" value=\"7\">7</button>\r\n    <button type=\"button\" (click) = \"getNumber('8')\" value=\"8\">8</button>\r\n    <button type=\"button\" (click) = \"getNumber('9')\" value=\"9\">9</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('4')\" value=\"4\">4</button>\r\n    <button type=\"button\" (click) = \"getNumber('5')\" value=\"5\">5</button>\r\n    <button type=\"button\" (click) = \"getNumber('6')\" value=\"6\">6</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('1')\" value=\"1\">1</button>\r\n    <button type=\"button\" (click) = \"getNumber('2')\" value=\"2\">2</button>\r\n    <button type=\"button\" (click) = \"getNumber('3')\" value=\"3\">3</button>\r\n\r\n\r\n    <button type=\"button\" (click) = \"getNumber('0')\" value=\"0\">0</button>\r\n    <button type=\"button\" (click) = \"getDecimal()\" class=\"decimal\" value=\".\">.</button>\r\n    <button type=\"button\" (click) = \"clear()\"  class=\"all-clear\" value=\"all-clear\">C</button>\r\n\r\n    <button type=\"button\" (click) = \"getOperation('=')\" class=\"equal-sign\" value=\"=\">=</button>\r\n  </div>\r\n</div>\r\n", styles: [".calculator{border:1px solid #ccc;border-radius:5px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:400px;background-color:#fff}.calculator-screen{width:100%;font-size:36px;height:80px;border:none;background-color:#1579ab;color:#fff;text-align:right;padding-right:20px;padding-left:10px}button{height:60px;background-color:#fff;border-radius:3px;border:1px solid #c4c4c4;background-color:transparent;font-size:22px;color:#1579ab;background-image:linear-gradient(to bottom,transparent,transparent 50%,rgba(0,0,0,.04));box-shadow:inset 0 0 0 1px #ffffff0d,inset 0 1px #ffffff73,inset 0 -1px #ffffff26,0 1px #ffffff26;text-shadow:0 1px rgba(255,255,255,.4)}button:hover{background-color:#eaeaea}.operator{color:#337cac}.all-clear{background-color:#1579ab;border-color:#1579ab;color:#fff}.all-clear:hover{background-color:#1579ab}.equal-sign{background-color:#1579ab;border-color:#1579ab;color:#fff;height:100%;grid-area:2 / 4 / 6 / 5}.equal-sign:hover{background-color:#1579ab}.calculator-keys{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:10px;padding:10px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { calculatedResult: [{
                type: Output
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

class EipCalculatorModule {
}
EipCalculatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EipCalculatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorModule, declarations: [EipCalculatorComponent], imports: [DragDropModule], exports: [EipCalculatorComponent] });
EipCalculatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorModule, imports: [[
            DragDropModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EipCalculatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EipCalculatorComponent],
                    imports: [
                        DragDropModule
                    ],
                    exports: [EipCalculatorComponent]
                }]
        }] });

/*
 * Public API Surface of eip-calculator
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EipCalculatorComponent, EipCalculatorModule, EipCalculatorService };
